"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["children", "classes", "containerId", "dataTestId", "element", "isFullHeight", "isFullWidth", "role", "verticalSpacing"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var containerElementOptions = ['section', 'aside', 'article', 'footer', 'header', 'div'];
var containerRoles = {
  footer: 'contentinfo',
  header: 'banner',
  aside: 'complementary'
};
var Container = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      classes = _ref.classes,
      containerId = _ref.containerId,
      dataTestId = _ref.dataTestId,
      element = _ref.element,
      isFullHeight = _ref.isFullHeight,
      isFullWidth = _ref.isFullWidth,
      role = _ref.role,
      verticalSpacing = _ref.verticalSpacing,
      additionalProps = _objectWithoutProperties(_ref, _excluded);

  var ContainerTag = element;
  return /*#__PURE__*/_react.default.createElement(ContainerTag, _extends({
    "data-testid": dataTestId,
    id: containerId,
    role: role || containerRoles[element],
    className: (0, _classnames.default)("container", _defineProperty({
      'container--full-width': isFullWidth,
      'container--full-height': isFullHeight
    }, "container-vertical-spacing--".concat(verticalSpacing), verticalSpacing), classes),
    ref: ref
  }, additionalProps), /*#__PURE__*/_react.default.createElement("div", {
    className: "container__inner"
  }, children));
});
Container.displayName = 'Container';
Container.propTypes = {
  /**
   Required. The contents of the container element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,

  /**
   Optional. String to add custom class(es) to the component. Defaults to `null`.
   */
  classes: _propTypes.default.string,

  /**
   Optional. A unique identifier passed to the element's `id` attribute. Defaults to `null`.
   */
  containerId: _propTypes.default.string,

  /**
   Optional. A unique identifier passed to the element for use in testing scenarios. Defaults to `null`.
   */
  dataTestId: _propTypes.default.string,

  /**
   Optional. The HTML element used for the parent container element. Defaults to `"section"`.
   */
  element: _propTypes.default.oneOf(containerElementOptions),

  /**
   Optional. Allows the container to take up the full height of the viewport. Defaults `false`.
   */
  isFullHeight: _propTypes.default.bool,

  /**
   Optional. Allows the container to take up the full width of the viewport. Defaults `false`.
   */
  isFullWidth: _propTypes.default.bool,

  /**
   Optional. Sets the element's <a href=" https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles">ARIA role</a> attribute. The roles for header, footer, and aside are automatically set by the component. Defaults to `null`.
   */
  role: _propTypes.default.oneOf(['alert', 'application', 'article', 'banner', 'button', 'cell', 'checkbox', 'comment', 'complementary', 'contentinfo', 'dialog', 'document', 'feed', 'figure', 'form', 'grid', 'gridcell', 'heading', 'img', 'list', 'listbox', 'listitem', 'main', 'mark', 'navigation', 'region', 'row', 'rowgroup', 'search', 'suggestion', 'switch', 'tab', 'table', 'tabpanel', 'textbox', 'timer']),

  /**
   Optional. Sets the top and bottom padding for the container. Defaults to `"60"`.
   */
  verticalSpacing: _propTypes.default.oneOf(['0', '10', '20', '30', '40', '50', '60', '70', '80', '90', '100', '110', '120', '130'])
};
Container.defaultProps = {
  classes: null,
  containerId: null,
  dataTestId: null,
  element: 'section',
  isFullHeight: false,
  isFullWidth: false,
  role: null,
  verticalSpacing: '60'
};
var _default = Container;
exports.default = _default;